module.exports = __webpack_public_path__ + "img/index-using.3f9a0773.png";